/**
 * Avidity Cleaning Services company logo.
 * `size` sets the height (sm 32px / md 56px / lg 112px); width is auto so the
 * oval logo keeps its natural aspect ratio.
 * `withWordmark` shows the company name beside the mark.
 */
const HEIGHTS = { sm: 32, md: 56, lg: 112 };

export default function Logo({ size = "sm", withWordmark = false, invert = false, className = "" }) {
  const h = HEIGHTS[size] || HEIGHTS.sm;
  return (
    <div className={`flex items-center gap-3 ${className}`}>
      <img
        src="/avidity-logo.png"
        alt="Avidity Cleaning Services"
        data-testid="avidity-logo"
        className="object-contain shrink-0"
        style={{ height: h, width: "auto" }}
      />
      {withWordmark && (
        <div className="leading-none">
          <div className={`font-black tracking-tighter text-lg ${invert ? "text-white" : "text-gray-900"}`}>
            AVIDITY
          </div>
          <div className={`text-[10px] uppercase tracking-widest mt-1 ${invert ? "text-white/60" : "text-gray-500"}`}>
            Cleaning Services
          </div>
        </div>
      )}
    </div>
  );
}
